var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"loader-wrapper"}},[_c('div',{attrs:{"id":"loader"}}),_vm._v(" "),_c('div',{staticClass:"loader-section section-left"}),_vm._v(" "),_c('div',{staticClass:"loader-section section-right"}),_vm._v(" "),_c('div',{staticClass:"load_title"},[_vm._t("content")],2)])])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/load/loadcartoon.vue